import { MONTH_NAMES } from './constants'

export const capitalize = (s) => s[0].toUpperCase() + s.slice(1)

export function getMonthInCase(monthName) {
  const monthCases = {
    январь: 'января',
    февраль: 'февраля',
    март: 'марта',
    апрель: 'апреля',
    май: 'мая',
    июнь: 'июня',
    июль: 'июля',
    август: 'августа',
    сентябрь: 'сентября',
    октябрь: 'октября',
    ноябрь: 'ноября',
    декабрь: 'декабря'
  }

  if (typeof monthName === 'number') {
    const month = MONTH_NAMES[monthName]
    const keys = Object.keys(monthCases)
    let result = null

    for (let i = 0; i < keys.length; i++) {
      const el = keys[i]

      if (month.toLowerCase() === el) {
        result = monthCases[el]
        break
      }
    }

    return result
  }

  if (typeof monthName === 'string') {
    return monthCases[monthName.toLowerCase()] || null
  }
}

export function mergeUniqueArrays(arr1, arr2, key) {
  const mergedArray = [...arr1, ...arr2]
  const uniqueSet = new Set()
  const uniqueArray = []

  for (const item of mergedArray) {
    if (!uniqueSet.has(item[key])) {
      uniqueSet.add(item[key])
      uniqueArray.push(item)
    }
  }

  return uniqueArray
}
